import { PublicSession, SessionInvitesStatus } from "@classview/shared-types";

export function getSessionOrganisation(
  organisations: PublicSession["invitedOrganisations"],
) {
  return organisations.find((org) => org.status === SessionInvitesStatus.HOST);
}
